import { API } from '../../../../../api'
import { PageList } from '../../../utils'

import { QUERY } from './queries'

const List: PageList<API.course_homeworks_index> = {
  queryKey: 'courseHomeworks',
  query: QUERY,
}

export default List
